import { Modal as antModal, ModalFuncProps as antModalFuncProps } from "antd";
import { omit } from "lodash";
import styles from "./Modal.module.scss";

type ModalFuncProps = Omit<antModalFuncProps, "className" | "closable" | "centered" | "icon">;

/**
 * The button shape every dialog in the app uses. Merged with whatever the caller passes rather than
 * replaced by it: these used to sit before the `...props` spread, so a caller adding one property —
 * `disabled`, `danger` — silently dropped the shape and got a square button. Every call site in the
 * repo restated `shape: "round"` to work around that, which is the same bug written a dozen times.
 */
const ROUND_BUTTON = { shape: "round" as const, style: { minWidth: "92px" } };

const Modal = omit(antModal, "confirm", "error") as typeof antModal;
Modal.confirm = function (props: ModalFuncProps) {
  return antModal.confirm({
    bodyStyle: { borderBottom: "1px solid #F0F0F0" },
    ...props,
    okButtonProps: { ...ROUND_BUTTON, ...props.okButtonProps },
    cancelButtonProps: { ...ROUND_BUTTON, ...props.cancelButtonProps },
    icon: undefined,
    closable: true,
    centered: true,
    className: styles.confirm,
  });
};

Modal.error = function (props: ModalFuncProps) {
  return antModal.error({
    ...props,
    centered: true,
    className: styles.container,
    okButtonProps: { ...ROUND_BUTTON, ...props.okButtonProps },
    cancelButtonProps: { ...ROUND_BUTTON, ...props.cancelButtonProps },
  });
};

export default Modal;
